// src/App.tsx
/**
 * .tuMetrics {"tu1": 0.86, "tu2": 0.88, "tu3": 7, "notes": "App root now resets core bootstrap readiness on sign-out to prevent stale route gating", "tuVersion": "2.5"}
 * .help "Application root that initializes auth and renders routed pages within shared providers."
 */
import { useEffect } from 'react';
import Pages from './pages';
import useUserStore from './store/userStore';
import { supabase } from './lib/supabase';
import { HelpProvider } from './contexts/HelpContext';
import { isAuthSessionLost } from './store/user/authDecision';
import AppUpdateHost from './features/pwa/AppUpdateHost';

function App() {
  const { initializeAuth, hasInitializedAuth } = useUserStore();

  useEffect(() => {
    if (!hasInitializedAuth) {
      initializeAuth();
    }

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      if (isAuthSessionLost(event, session)) {
        void useUserStore.getState().sessionLost({ redirect: true });
      }
    });

    const onVisible = () => {
      if (document.visibilityState !== 'visible') return;
      void (async () => {
        const {
          data: { session },
        } = await supabase.auth.getSession();
        const { currentUser, isAuthenticated } = useUserStore.getState();
        if (!session && (currentUser || isAuthenticated)) {
          void useUserStore.getState().sessionLost({ redirect: true });
        }
      })();
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      subscription.unsubscribe();
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [initializeAuth, hasInitializedAuth]);

  return (
    <HelpProvider>
      <Pages />
      <AppUpdateHost />
    </HelpProvider>
  );
}

export default App;
